
import { fetchShowStartpage } from '@/api/settingUser';
import { createFileRoute, redirect, useNavigate } from '@tanstack/react-router';
import React from 'react';

export const Route = createFileRoute('/_auth/begin')({
    component: BeginPage,
    loader: () => {
        const storage = sessionStorage
        const accessKey = storage.getItem('AccessKey')
        if (accessKey && storage.getItem('requestedUrl')) {
            let requestedUrl = storage.getItem('requestedUrl') || ''
            requestedUrl = requestedUrl.replace(window.location.origin, '')
            console.log(requestedUrl)
            storage.removeItem('requestedUrl')

            console.log('redirecting to', requestedUrl)
            redirect({ to: requestedUrl, throw: true });
        }
        localStorage.removeItem('expireTime');
    }
})

function BeginPage() {

    const navigate = useNavigate()

    React.useEffect(() => {
        const storage = sessionStorage

        const accessKey = storage.getItem('AccessKey')
        if (!accessKey) {
            console.log('navigate from begin to start because no access key')
            navigate({ to: '/start' })
            return
        }
        fetchShowStartpage().then((showStartpageSetting) => {
            const show = showStartpageSetting as unknown as boolean
            if (show == true) {
                console.log('navigate from begin to start')
                navigate({ to: '/start' });
            } else {
                console.log('navigate to membershipsOverview')
                navigate({
                    to: '/membershipsOverview',
                    search: {
                        filter: [
                            { field: "active", operator: "is", value: "true" },
                            { field: "scoutstate", operator: "isAnyOf", value: ['MEMBER_FULL', 'MEMBER_ADD'] }
                        ],
                        sort: [{ field: "member.scoutId", direction: "asc" }],
                        visibility: [{ field: "properties.joblist" }, { field: "properties.section" }],
                    }
                })
            }
        })
    }, [navigate])
    return <></>
}
